
import 'rc-slider/assets/index.css';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withApollo, Query } from 'react-apollo'
import { Col, Row } from 'reactstrap';
import DataLoader from '../../app/DataLoader'
import { signout } from '../../redux/actions/userActions';

import { GetSRASections } from '../../queries/assessment';
import SRAReportModal from './SRAReportModal';
import SRASection from './components/SRASection';
import { loader as Loader } from '../Loader';

import stairs from '../../img/SRA/stairs.png';
import stairs_light from '../../img/SRA/stairs_light.png';
import policy from '../../img/SRA/policy.png';
import policy_light from '../../img/SRA/policy_light.png';
import workforce from '../../img/SRA/workforce.png';
import workforce_light from '../../img/SRA/workforce_light.png';
import data from '../../img/SRA/data.png';
import data_light from '../../img/SRA/data_light.png';
import practice from '../../img/SRA/practice.png';
import practice_light from '../../img/SRA/practice_light.png';
import associates from '../../img/SRA/associates.png';
import associates_light from '../../img/SRA/associates_light.png';
import plan from '../../img/SRA/plan.png';
import plan_light from '../../img/SRA/plan_light.png';

class SRAMainPage extends React.Component {

    state = {
        isReportModalOpen: false,
        overallRisk: {},
        sections: []
    }

    //opens/closes report modal
    toggleReportModal = () => {
        this.setState({
            isReportModalOpen: !this.state.isReportModalOpen
        })
    }

    //map backend section data to images and front end friendly names
    setupSectionData = sections => {
        let mappedSections = [];
        sections.forEach((section, sectionIndex) => {

            let _section = {
                progress: Math.floor(section.progress),
                riskScore: section.riskScore,
                sectionName: section.section,
                backendSectionName: section.sectionName
            };

            switch (_section.backendSectionName) {
                case SECTION_MAPPING.SECURITY_MANAGEMENT:
                    _section.incompleteImage = stairs
                    _section.completeImage = stairs_light
                    break;
                case SECTION_MAPPING.POLICIES_AND_PROCEDURES:
                    _section.incompleteImage = policy
                    _section.completeImage = policy_light
                    break;
                case SECTION_MAPPING.WORKFORCE_MANAGEMENT:
                    _section.incompleteImage = workforce
                    _section.completeImage = workforce_light
                    break;
                case SECTION_MAPPING.DATA_SECURITY:
                    _section.incompleteImage = data
                    _section.completeImage = data_light
                    break;
                case SECTION_MAPPING.PHYSICAL_SECURITY:
                    _section.incompleteImage = practice
                    _section.completeImage = practice_light
                    break;
                case SECTION_MAPPING.SUPPLY_CHAIN:
                    _section.incompleteImage = associates
                    _section.completeImage = associates_light
                    break;
                case SECTION_MAPPING.CONTINGENCY_PLANNING:
                    _section.incompleteImage = plan
                    _section.completeImage = plan_light
                    break;
                default:
                    break;
            }
            mappedSections.push(_section);
        })

        return mappedSections;
    }

    //renders each section with correct props from state.sections
    renderSections = () => {
        return this.state.sections.map((section, sectionIndex) => {
            return <SRASection
                key={sectionIndex}
                sectionKey={sectionIndex}
                sectionProgress={section.progress}
                sectionName={section.sectionName}
                backendSectionName={section.backendSectionName}
                completeImage={section.completeImage}
                incompleteImage={section.incompleteImage} />
        })
    }

    //loads page data after query is complete
    renderPageComponents = () => {
        return (
            <React.Fragment>
                <div className="comp-assessment list">
                    <div>
                        <Row>
                            <Col md={12} id="security_risk_assessment">
                                <h3 className='page-title'>HIPAA Security Risk Assessment</h3>
                                <h3 className='page-subhead subhead'>
                                    The HIPAA Security Rule requires Covered Entities and Business Associates to
                                    identity and manage risks to electronic protected health information (e-PHI).
                                    This assessment allows you to identify vulnerabilities and threats to e-PHI, assess
                                    the impact and likelihood of potential breaches and should guide your
                                    implementation of required safeguards to protect e-PHI.
                                    </h3>
                                <button
                                    style={{ margin: '30px auto' }}
                                    className='btn btn-primary account__btn generate__report'
                                    onClick={() => this.toggleReportModal()}>
                                    Generate Report
                                </button>
                            </Col>
                        </Row>
                    </div>
                    <div className="risk__progresses">
                        {this.renderSections()}
                    </div>
                </div >
                {
                    this.state.isReportModalOpen &&
                    <SRAReportModal
                        toggle={this.toggleReportModal}
                        modal={this.state.modal}
                        overallRisk={this.state.overallRisk}
                        sections={this.state.sections} />
                }
            </React.Fragment >
        )
    }

    render () {
        return (
            <DataLoader>
                <div className="project-container">
                    <Query
                        query={GetSRASections()}
                        fetchPolicy={'network-only'}
                        onError={(e) => {
                            if (e.networkError) {
                                if (e.networkError['statusCode'] === 401) {
                                    console.log("401 error")
                                }
                            } else {
                                console.log(e.message)
                            }
                        }}
                        onCompleted={(data) => {
                            this.setState({
                                overallRisk: data.getSRASectionNames.overallRisk,
                                sections: this.setupSectionData(data.getSRASectionNames.sections)
                            })
                        }}>
                        {({ loading, error, data }) => {
                            if (!loading && this.props.dataLoaded) {
                                if (data && data.getSRASectionNames) {
                                    return this.renderPageComponents()
                                }
                            } else if (error) {
                                console.log(`ERROR > ${error.message}`)
                                return null
                            } else {
                                return <Loader />
                            }
                        }}
                    </Query>
                </div>
            </DataLoader >
        )
    }
}

function mapStateToProps (state) {
    return {
        user: state.auth.user,
        enabledFrameworks: state.controlsData.enabledFrameworks,
        dataLoaded: !state.controlsData.loading,
        sidebar: state.sidebar
    }
}

//used to map sections with correct images
const SECTION_MAPPING = {
    SECURITY_MANAGEMENT: "sra:security management",
    POLICIES_AND_PROCEDURES: "sra:policies and procedures",
    WORKFORCE_MANAGEMENT: "sra:workforce management",
    DATA_SECURITY: "sra:data security",
    PHYSICAL_SECURITY: "sra:physical security",
    SUPPLY_CHAIN: "sra:supply chain management",
    CONTINGENCY_PLANNING: "sra:contingency planning"
}

export default connect(mapStateToProps, { signout })(withRouter(withApollo(SRAMainPage)))


// WEBPACK FOOTER //
// ./src/components/sra/SRAMainPage.js